import { useState, useEffect } from 'react';
import {
  ProductListItemViewModel,
  BasketRowViewModel,
  Website
} from '../types/generated';
import ProductPod from './ProductPod';
import { PageLocation, TransactionalCurrency } from '../types/enums';
import { getBasketCatalogueRefs } from '../apps/basket/basketApi';
import canUseDOM from '../utilities/canUseDOM';
import { createCurrencyCode } from '../utilities/formatCurrency';
import * as basketApi from '../apps/basket/basketApi';
import { addGA4ProductListingEvent } from '../helpers/ga4';

export interface ProductListProps {
  products: ProductListItemViewModel[] | null;
  transactionalCurrency: TransactionalCurrency;
  showSecondaryPrice: boolean;
  website: Website;
  isCssFavouritesEnabled?: boolean;
}

export default function ProductList({
  products,
  transactionalCurrency,
  showSecondaryPrice,
  website,
  isCssFavouritesEnabled
}: ProductListProps) {
  const [catalogueRefs, setCatalogueRefs] = useState<string[]>([]);

  useEffect(() => {
    if (canUseDOM()) {
      getBasketCatalogueRefs().then((refs) => {
        setCatalogueRefs(refs);
      });
    }
  }, []);

  useEffect(() => {
    window._sqzl = window._sqzl || [];
    window.monetateQ = window.monetateQ || [];
    window.monetateQ.push(['setPageType', 'index']);
    if (products && products.length > 0) {
      {
        const squeezelyProducts: any[] = [];
        products?.map((product) => {
          window.monetateQ.push([
            'addProducts',
            [
              {
                productId: product.catalogueRef,
                sku: product.sku
              }
            ]
          ]);

          squeezelyProducts.push({
            id: product.catalogueRef,
            name: product.name,
            price: product.priceExcVat
          });
        });

        window._sqzl.push({
          event: 'ViewContent',
          products: squeezelyProducts
        });

        console.log(
          products.length + '  ProductList ViewContent event sent to squeezely'
        );

        addGA4ProductListingEvent(products);
      }
    }
    window.monetateQ.push(['trackData']);
  }, [products]);

  if (!products || products.length === 0) {
    return null;
  }

  function trackAddToBasket() {
    basketApi
      .getBasket()
      .then((response) => {
        window.monetateQ = window.monetateQ || [];
        window.monetateQ.push(['setPageType', 'index']);
        if (products && products?.length > 0) {
          {
            products?.map((product) => {
              window.monetateQ.push([
                'addProducts',
                [
                  {
                    productId: product.catalogueRef,
                    sku: product.sku
                  }
                ]
              ]);
            });
          }
        }
        if (response.hasRows) {
          response.rows?.forEach((element: BasketRowViewModel) => {
            window.monetateQ.push([
              'addCartRows',
              [
                {
                  productId: element.catalogueRef,
                  sku: element.sku,
                  quantity: element.quantity,
                  unitPrice: element.priceExcVat,
                  currency: createCurrencyCode(transactionalCurrency)
                }
              ]
            ]);

            window._sqzl.push({
              event: 'AddToCart',
              products: [
                {
                  id: element.catalogueRef,
                  price: element.priceExcVat,
                  quantity: element.quantity
                }
              ]
            });
          });

          console.log('1 ProductList AddToCart event sent to squeezely');
        }
        window.monetateQ.push(['trackData']);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  return (
    <div className="row">
      {products.map((product) => {
        const isSearchPod =
          product.sliLogUrl !== null && product.sliLogUrl !== '';
        const sliClickTrigger = isSearchPod ? ' js-sli-click-trigger' : '';
        const sliClickAttributes = isSearchPod
          ? {
              'data-click-url': product.sliLogUrl,
              'data-catalogue-ref': product.catalogueRef
            }
          : {};
        return (
          <div
            key={product.productId}
            className={
              'product-list__item col-sm-6 col-lg-4 col-xl-3' + sliClickTrigger
            }
            {...sliClickAttributes}
          >
            <ProductPod
              transactionalCurrency={transactionalCurrency}
              {...product}
              isAdded={
                product.catalogueRef != null
                  ? catalogueRefs.includes(product.catalogueRef)
                  : false
              }
              showSecondaryPrice={showSecondaryPrice}
              website={website}
              onTrackAddToBasketMonetate={trackAddToBasket}
              location={PageLocation.PLP}
              isCssFavouritesEnabled={isCssFavouritesEnabled}
            />
          </div>
        );
      })}
    </div>
  );
}
